// src/services/apiService.js
import { supabase } from "../supabaseClient";
const API_BASE_URL = "https://alternative-lamprey-fatma-celik-a9c7fc96.koyeb.app/api";

// Token'ı localStorage'a kaydetme
export const setToken = (token) => {
  try {
    localStorage.setItem("jwt_token", token);
  } catch (error) {
    console.error("Token kaydedilemedi:", error);
  }
};

// Token'ı localStorage'dan alma
export const getToken = () => {
  try {
    return localStorage.getItem("jwt_token");
  } catch (error) {
    console.error("Token okunamadı:", error);
    return null;
  }
};

// Token'ı silme
export const removeToken = () => {
  try {
    localStorage.removeItem("jwt_token");
  } catch (error) {
    console.error("Token silinemedi:", error);
  }
};

// Kullanıcı bilgilerini localStorage'a kaydetme
export const setUser = (user) => {
  try {
    localStorage.setItem("user", JSON.stringify(user));
  } catch (error) {
    console.error("Kullanıcı bilgileri kaydedilemedi:", error);
  }
};

// Kullanıcı bilgilerini localStorage'dan alma
export const getUser = () => {
  try {
    const userStr = localStorage.getItem("user");
    if (userStr) {
      return JSON.parse(userStr);
    }
    return null;
  } catch (error) {
    console.error("Kullanıcı bilgileri okunamadı:", error);
    return null;
  }
};

// Kullanıcı bilgilerini ve token'ı temizleme
export const clearAuth = () => {
  try {
    localStorage.removeItem("jwt_token");
    localStorage.removeItem("user");
  } catch (error) {
    console.error("Auth temizlenemedi:", error);
  }
};

// Giriş yapma
export const login = async (email, password) => {
  try {
    console.log("Giriş yapılıyor:", email);
    const response = await fetch(`${API_BASE_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });
    console.log("Response status:", response.status);
    if (!response.ok) {
      const errorData = await response.json();
      console.error("Login error:", errorData);
      throw new Error(errorData.error || "Giriş yapılırken hata oluştu");
    }
    const data = await response.json();
    console.log("Login response:", data);
    if (data.success) {
      // Token'ı ve kullanıcı bilgilerini localStorage'a kaydet
      setToken(data.token);
      setUser(data.user);
      return { success: true, user: data.user };
    } else {
      throw new Error(data.error || "Giriş başarısız");
    }
  } catch (error) {
    console.error("Login exception:", error);
    return { success: false, error: error.message };
  }
};

// Çıkış yapma
export const logout = () => {
  clearAuth();
};

// Şifre değiştirme
export const changePassword = async (currentPassword, newPassword) => {
  const token = getToken();
  if (!token) {
    throw new Error("Oturum açılmamış");
  }
  try {
    console.log("🔄 Şifre değiştirme isteği gönderiliyor...");
    const response = await fetch(`${API_BASE_URL}/change-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        current_password: currentPassword,
        new_password: newPassword,
      }),
    });
    console.log("📡 Response status:", response.status);
    const data = await response.json();
    console.log("📦 Response data:", data);
    if (!response.ok) {
      throw new Error(data.error || "Şifre değiştirilemedi");
    }
    return data;
  } catch (error) {
    console.error("❌ Şifre değiştirme hatası:", error);
    throw new Error(error.message || "Şifre değiştirilirken hata oluştu");
  }
};

// Yetkili istekler için fetch wrapper
export const authFetch = async (url, options = {}) => {
  const token = getToken();
  console.log(
    "🔍 Gönderilen token:",
    token ? `${token.substring(0, 20)}...` : "Token yok"
  );
  const headers = {
    "Content-Type": "application/json",
    ...options.headers,
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
    console.log("🔍 Authorization header eklendi");
  }
  const response = await fetch(url, {
    ...options,
    headers,
  });
  console.log(
    `🔍 İstek: ${options.method || "GET"} ${url}, Status: ${response.status}`
  );
  // Eğer token süresi dolmuşsa (401), çıkış yap
  if (response.status === 401) {
    console.error("🚫 401 Unauthorized - Token süresi dolmuş");
    logout();
    window.location.href = "/login";
    throw new Error("Oturum süresi dolmuş, lütfen tekrar giriş yapın");
  }
  // 403 hatası için debug
  if (response.status === 403) {
    console.error("🚫 403 Forbidden - Yetki hatası");
    const errorText = await response.text();
    console.error("🚫 Hata detayı:", errorText);
  }
  return response;
};

// Rol kontrol fonksiyonları
export const isMaintenanceAdmin = (user) => {
  return user?.role?.toLowerCase() === "maintenance_admin";
};

export const canAccessAdminFeatures = (user) => {
  const role = user?.role?.toLowerCase();
  return role === "admin" || role === "maintenance_admin";
};

// Yönlendirme için yardımcı fonksiyon
export const redirectBasedOnRole = (user) => {
  if (!user || !user.role) return "/login";
  const role = user.role.toLowerCase();
  if (role === "maintenance_admin") {
    return "/maintenance";
  } else if (role === "admin") {
    return "/admin";
  } else if (role === "employee" || role === "user") {
    return "/employee";
  } else {
    return "/login";
  }
};

// apiService.js dosyasında getStats fonksiyonunu güncelleyin
export const getStats = async () => {
  try {
    console.log("🔄 getStats çağrıldı");
    const token = getToken();

    if (!token) {
      console.error("❌ Token bulunamadı");
      // Kullanıcıyı giriş sayfasına yönlendir
      window.location.href = "/login";
      throw new Error("Oturum açılmamış");
    }

    const response = await fetch(`${API_BASE_URL}/stats`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("📡 Stats response status:", response.status);

    if (!response.ok) {
      if (response.status === 401) {
        // Token süresi dolmuşsa çıkış yap ve yönlendir
        logout();
        window.location.href = "/login";
      }
      const errorText = await response.text();
      console.error("❌ İstatistikler API hatası:", errorText);
      throw new Error("İstatistikler yüklenemedi");
    }

    const data = await response.json();
    console.log("📦 İstatistikler verisi:", data);
    return data;
  } catch (error) {
    console.error("❌ İstatistikler çekme hatası:", error);
    // Hata durumunda kullanıcıyı giriş sayfasına yönlendir
    if (
      error.message === "Oturum açılmamış" ||
      error.message.includes("Token")
    ) {
      window.location.href = "/login";
    }
    return {
      users: 0,
      activeUsers: 0,
      todayEntries: 0,
      todayExits: 0,
      currentlyInOffice: 0,
    };
  }
};
// AdminPage için son aktiviteler - getRecentLogs yerine kullanılacak
export const getRecentActivities = async () => {
  try {
    console.log("🌐 API: getRecentActivities çağrılıyor");
    const token = getToken();
    if (!token) {
      throw new Error("Oturum açılmamış");
    }
    const response = await fetch(`${API_BASE_URL}/recent-movements`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("📡 getRecentActivities response status:", response.status);
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Son aktiviteler yüklenemedi: ${response.status} ${errorText}`
      );
    }
    const data = await response.json();
    console.log("📦 getRecentActivities cevabı:", data);
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("❌ Son aktiviteler çekme hatası:", error);
    return [];
  }
};

// AttendanceContent API'leri
export const getDailyAttendance = async () => {
  try {
    console.log("🌐 API: getDailyAttendance çağrılıyor");
    const token = getToken();
    if (!token) {
      throw new Error("Oturum açılmamış");
    }
    const response = await authFetch(`${API_BASE_URL}/daily-attendance`);
    if (!response.ok) {
      throw new Error("Günlük durum yüklenemedi");
    }
    const data = await response.json();
    console.log("🌐 API: getDailyAttendance cevabı:", data);
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("❌ Günlük durum çekme hatası:", error);
    return [];
  }
};

export const getCurrentlyInOffice = async () => {
  try {
    console.log("🌐 API: getCurrentlyInOffice çağrılıyor");
    const token = getToken();
    if (!token) {
      throw new Error("Oturum açılmamış");
    }
    const response = await authFetch(`${API_BASE_URL}/currently-in-office`);
    if (!response.ok) {
      throw new Error("Ofistekiler yüklenemedi");
    }
    const data = await response.json();
    console.log("🌐 API: getCurrentlyInOffice cevabı:", data);
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("❌ Ofistekiler çekme hatası:", error);
    return [];
  }
};

export const getRecentMovements = async () => {
  try {
    console.log("🌐 API: getRecentMovements çağrılıyor");
    const response = await authFetch(`${API_BASE_URL}/recent-movements`);
    if (!response.ok) throw new Error("Son hareketler yüklenemedi");
    const data = await response.json();
    console.log("🌐 API: getRecentMovements cevabı:", data);
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Son hareketler çekme hatası:", error);
    return [];
  }
};

// Personel Yönetimi API'leri
export const getEmployeeList = async () => {
  try {
    const response = await authFetch(`${API_BASE_URL}/employees`);
    if (!response.ok) throw new Error("Personel listesi yüklenemedi");
    return await response.json();
  } catch (error) {
    console.error("Personel listesi çekme hatası:", error);
    return [];
  }
};

export const addEmployee = async (employeeData) => {
  try {
    const response = await authFetch(`${API_BASE_URL}/employees`, {
      method: "POST",
      body: JSON.stringify(employeeData),
    });
    if (!response.ok) throw new Error("Personel eklenemedi");
    return await response.json();
  } catch (error) {
    console.error("Personel ekleme hatası:", error);
    return null;
  }
};

export const updateEmployee = async (id, employeeData) => {
  try {
    const response = await authFetch(`${API_BASE_URL}/employees/${id}`, {
      method: "PUT",
      body: JSON.stringify(employeeData),
    });
    if (!response.ok) throw new Error("Personel güncellenemedi");
    return await response.json();
  } catch (error) {
    console.error("Personel güncelleme hatası:", error);
    return null;
  }
};

export const toggleEmployeeStatus = async (id) => {
  try {
    const response = await authFetch(
      `${API_BASE_URL}/employees/${id}/toggle-status`,
      {
        method: "PUT",
      }
    );
    if (!response.ok) throw new Error("Personel durumu değiştirilemedi");
    return await response.json();
  } catch (error) {
    console.error("Personel durumu değiştirme hatası:", error);
    return null;
  }
};

// Raporlar API'leri
export const getMonthlyReport = async () => {
  try {
    const response = await authFetch(`${API_BASE_URL}/monthly-report`);
    if (!response.ok) throw new Error("Aylık rapor yüklenemedi");
    return await response.json();
  } catch (error) {
    console.error("Aylık rapor çekme hatası:", error);
    return [];
  }
};

export const getOvertimeReport = async () => {
  try {
    const response = await authFetch(`${API_BASE_URL}/overtime-report`);
    if (!response.ok) throw new Error("Fazla mesai raporu yüklenemedi");
    return await response.json();
  } catch (error) {
    console.error("Fazla mesai raporu çekme hatası:", error);
    return [];
  }
};

// Access Log API'si
export const saveAccessLog = async (logData) => {
  try {
    const response = await authFetch(`${API_BASE_URL}/access-logs`, {
      method: "POST",
      body: JSON.stringify(logData),
    });
    if (!response.ok) throw new Error("Access log kaydedilemedi");
    return await response.json();
  } catch (error) {
    console.error("Access log kaydetme hatası:", error);
    return null;
  }
};

// Employee (Çalışan) API'leri
export const getEmployeePersonalInfo = async (userId) => {
  try {
    const response = await authFetch(
      `${API_BASE_URL}/employees/${userId}/personal-info`
    );
    if (!response.ok) throw new Error("Personel bilgileri yüklenemedi");
    return await response.json();
  } catch (error) {
    console.error("Personel bilgileri çekme hatası:", error);
    return null;
  }
};

export const getPersonalWeeklySummary = async (userId) => {
  try {
    const response = await authFetch(
      `${API_BASE_URL}/personal-weekly-summary/${userId}`
    );
    if (!response.ok) throw new Error("Haftalık özet yüklenemedi");
    return await response.json();
  } catch (error) {
    console.error("Haftalık özet çekme hatası:", error);
    return [];
  }
};

export const getEmployeeMonthlyStatus = async (userId) => {
  try {
    const response = await authFetch(
      `${API_BASE_URL}/employee-monthly-status/${userId}`
    );
    if (!response.ok) throw new Error("Aylık durum yüklenemedi");
    return await response.json();
  } catch (error) {
    console.error("Aylık durum çekme hatası:", error);
    return {};
  }
};

export const getEmployeeTodayMovements = async (userId) => {
  try {
    const response = await authFetch(
      `${API_BASE_URL}/employees/${userId}/today-movements`
    );
    if (!response.ok) throw new Error("Günlük hareketler yüklenemedi");
    return await response.json();
  } catch (error) {
    console.error("Günlük hareketler çekme hatası:", error);
    return [];
  }
};

export const getEmployeePermissions = async (userId) => {
  try {
    const response = await authFetch(
      `${API_BASE_URL}/employees/${userId}/permissions`
    );
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "İzinler yüklenemedi");
    }
    return await response.json();
  } catch (error) {
    console.error("İzinler yüklenirken hata:", error);
    throw error;
  }
};

// İzin talebi oluşturan fonksiyon
export const createPermissionRequest = async (permissionData) => {
  try {
    const response = await authFetch(`${API_BASE_URL}/permissions`, {
      method: "POST",
      body: JSON.stringify(permissionData),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "İzin talebi oluşturulamadı");
    }
    return await response.json();
  } catch (error) {
    console.error("İzin talebi oluşturulurken hata:", error);
    throw error;
  }
};

// İzin durumunu güncelleme
export const updatePermissionStatus = async (permissionId, status) => {
  try {
    const response = await authFetch(
      `${API_BASE_URL}/permissions/${permissionId}/status`,
      {
        method: "PUT",
        body: JSON.stringify({ status }),
      }
    );
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "İzin durumu güncellenemedi");
    }
    return await response.json();
  } catch (error) {
    console.error("İzin durumu güncellenirken hata:", error);
    throw error;
  }
};

// Tüm izinleri getirme (Admin için)
export const getAllPermissions = async () => {
  try {
    const response = await authFetch(`${API_BASE_URL}/permissions`);
    if (!response.ok) throw new Error("İzinler yüklenemedi");
    return await response.json();
  } catch (error) {
    console.error("İzinler yüklenirken hata:", error);
    throw error;
  }
};

// İzin talebini güncelleme
export const updatePermissionRequest = async (permissionData) => {
  try {
    const response = await authFetch(
      `${API_BASE_URL}/permissions/${permissionData.permission_id}`,
      {
        method: "PUT",
        body: JSON.stringify({
          permission_type: permissionData.permission_type,
          start_date: permissionData.start_date,
          end_date: permissionData.end_date,
          reason: permissionData.reason,
        }),
      }
    );
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "İzin talebi güncellenemedi");
    }
    return await response.json();
  } catch (error) {
    console.error("İzin talebi güncellenirken hata:", error);
    throw error;
  }
};

// İzin talebini iptal etme
export const cancelPermissionRequest = async (permissionId) => {
  try {
    const response = await authFetch(
      `${API_BASE_URL}/permissions/${permissionId}/status`,
      {
        method: "PUT",
        body: JSON.stringify({ status: "canceled" }),
      }
    );
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "İzin talebi iptal edilemedi");
    }
    return await response.json();
  } catch (error) {
    console.error("İzin talebi iptal edilirken hata:", error);
    throw error;
  }
};

// Mesai Takvimi API'leri
export const getWorkSchedules = async (userId) => {
  try {
    const response = await authFetch(
      `${API_BASE_URL}/employees/${userId}/work-schedules`
    );
    if (!response.ok) throw new Error("Mesai takvimi yüklenemedi");
    return await response.json();
  } catch (error) {
    console.error("Mesai takvimi yüklenirken hata:", error);
    throw error;
  }
};

export const createWorkSchedule = async (scheduleData) => {
  try {
    const response = await authFetch(`${API_BASE_URL}/work-schedules`, {
      method: "POST",
      body: JSON.stringify(scheduleData),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Mesai kaydı oluşturulamadı");
    }
    return await response.json();
  } catch (error) {
    console.error("Mesai kaydı oluşturulurken hata:", error);
    throw error;
  }
};

export const updateWorkSchedule = async (scheduleId, scheduleData) => {
  try {
    const response = await authFetch(
      `${API_BASE_URL}/work-schedules/${scheduleId}`,
      {
        method: "PUT",
        body: JSON.stringify(scheduleData),
      }
    );
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Mesai kaydı güncellenemedi");
    }
    return await response.json();
  } catch (error) {
    console.error("Mesai kaydı güncellenirken hata:", error);
    throw error;
  }
};

export const deleteWorkSchedule = async (scheduleId) => {
  try {
    const response = await authFetch(
      `${API_BASE_URL}/work-schedules/${scheduleId}`,
      {
        method: "DELETE",
      }
    );
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Mesai kaydı silinemedi");
    }
    return await response.json();
  } catch (error) {
    console.error("Mesai kaydı silinirken hata:", error);
    throw error;
  }
};

// Maintenance API'leri
export const getSystemInfo = async () => {
  try {
    const response = await authFetch(`${API_BASE_URL}/maintenance/system-info`);
    if (!response.ok) throw new Error("Sistem bilgileri yüklenemedi");
    return await response.json();
  } catch (error) {
    console.error("Sistem bilgileri çekme hatası:", error);
    return null;
  }
};

export const resetUserPassword = async (userId) => {
  try {
    const response = await authFetch(
      `${API_BASE_URL}/maintenance/reset-user-password/${userId}`,
      {
        method: "POST",
      }
    );
    if (!response.ok) throw new Error("Şifre sıfırlanamadı");
    return await response.json();
  } catch (error) {
    console.error("Şifre sıfırlama hatası:", error);
    return null;
  }
};

// Profil güncelleme
export const updateProfile = async (profileData) => {
  try {
    const response = await authFetch(`${API_BASE_URL}/profile`, {
      method: "PUT",
      body: JSON.stringify(profileData),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Profil güncellenemedi");
    }
    return await response.json();
  } catch (error) {
    console.error("Profil güncellenirken hata:", error);
    throw error;
  }
};

// Şifre sıfırlama talebi
export const requestPasswordReset = async (email) => {
  try {
    const response = await fetch(`${API_BASE_URL}/request-password-reset`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.error || "Şifre sıfırlama talebi gönderilemedi"
      );
    }
    return await response.json();
  } catch (error) {
    console.error("Şifre sıfırlama talebi gönderilirken hata:", error);
    throw error;
  }
};

// Şifre sıfırlama
export const resetPassword = async (token, newPassword) => {
  try {
    const response = await fetch(`${API_BASE_URL}/reset-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token, newPassword }),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Şifre sıfırlanamadı");
    }
    return await response.json();
  } catch (error) {
    console.error("Şifre sıfırlanırken hata:", error);
    throw error;
  }
};

// Giriş/Çıkış kaydı
export const recordAttendance = async (attendanceData) => {
  try {
    const response = await authFetch(`${API_BASE_URL}/attendance`, {
      method: "POST",
      body: JSON.stringify(attendanceData),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Giriş/Çıkış kaydedilemedi");
    }
    return await response.json();
  } catch (error) {
    console.error("Giriş/Çıkış kaydedilirken hata:", error);
    throw error;
  }
};

// Bugünkü giriş/çıkış durumunu kontrol etme
export const checkTodayAttendance = async (userId) => {
  try {
    const response = await authFetch(
      `${API_BASE_URL}/employees/${userId}/today-attendance`
    );
    if (!response.ok) throw new Error("Günlük durum kontrol edilemedi");
    return await response.json();
  } catch (error) {
    console.error("Günlük durum kontrol edilirken hata:", error);
    throw error;
  }
};
